module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: {
      global: _vm.global
    }
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": "#f9f300"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65ba0e18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65ba0e18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/loader.vue
// module id = 841
// module chunks = 0